import { CurrencyType } from '@model/WalletDto'

export const currencyToSymbol = (currency?: CurrencyType): string | null => {
  const dummyDigit = 0
  if (!currency) {
    return null
  }
  return dummyDigit
    .toLocaleString('en', {
      style: 'currency',
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
    .replace('0.00', '')
}
